<template>
    <component
        :is="linkComponent"
        v-bind="linkProps"
        :class="customClass"
    >
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "zoezi-link",
    props: {
        link: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        linkComponent() {
            if (this.$root.edit) {
                return 'div'; // No link in edit mode
            }

            if (this.link?.href) {
                return 'a'; // External link
            } else if (this.link?.page) {
                return 'router-link'; // Internal Vue Router link
            } else {
                return 'div'; // No link
            }
        },
        linkProps() {
            if (this.link?.href) {
                return { href: this.link.href, target: this.target, rel: this.relAttr };
            }
            if (this.link?.page) {
                return { to: { path: this.link.page, hash: this.link.anchor ? `#${this.link.anchor}` : '' } };
            }
            return {}; // No bindings for div
        },
        target() {
            return this.link?.newTab ? "_blank" : null;
        },
        relAttr() {
            return this.link?.newTab ? "noopener noreferrer" : null;
        }
    }
};
</script>
